/** Human labels for decoded telemetry keys, shared by the latest-signals grid
 *  and the record table so the two never drift. Anything unlisted is derived
 *  from the key (snake_case → Title Case). */
export const SIGNAL_LABELS: Record<string, string> = {
  soc: "SoC", pack_v: "Pack V", pack_i: "Pack I", speed_kmph: "Speed",
  temp_max_c: "Temp max", cell_min_mv: "Cell min", cell_max_mv: "Cell max",
  cell_delta_mv: "Cell Δ", cell_min_idx: "Weak cell", cells: "Cells",
  lat: "Lat", lng: "Lng",
  motor_rpm: "Motor RPM", gear: "Gear", supply_v_mv: "Supply mV", odometer_m: "Odometer m",
  trip_m: "Trip m", status_bits: "Status bits", motion_flags: "Motion flags",
  motor_temp_decic: "Motor temp", mctrl_temp_decic: "Ctrl temp", battery_temp_decic: "Batt temp",
  motor_err_bits: "Motor errs", mctrl_err_bits: "Ctrl errs", throttle_err_bits: "Throttle errs",
  battery_err_bits: "Batt errs", batt_alarm_bits: "Batt alarms",
  motor_data_source: "Motor src", battery_data_source: "Batt src",
  hw_version: "HW rev", app_sw_version: "App ver", boot_sw_version: "Boot ver",
  cluster_id: "Cluster ID", vehicle_id: "Vehicle ID", can_slot_0: "CAN 0", can_slot_1: "CAN 1",
  batt_company_id: "Batt vendor", batt_soh_pct: "SoH %", batt_cycle_count: "Cycles",
  batt_capacity_mah: "Capacity mAh", batt_load_status: "Load", batt_pack_id: "Pack ID",
  gps_fix: "GPS fix", gps_sat: "GPS sats", gps_hdop_d: "HDOP", gps_speed_dkmh: "GPS speed",
  gps_heading_deg: "Heading", gps_alt_dm: "Altitude",
};

export function pretty(k: string): string {
  return SIGNAL_LABELS[k] ?? k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
